export const studiesInput = [
  {
    label: 'Rx Panoramica',
    slug: 'rxpanoramica',
  },
  {
    label: 'Telerradiografia',
    slug: 'telerradiografia',
  },
  {
    label: 'Ricketts',
    slug: 'ricketts',
  },

  // 'otros1',
  // 'otros2',
  // 'otros3',
  // 'otros4',
  // 'otros5',
]
